import ReactDOM from 'react-dom/client'
import '@core/translations'
import { DayJSMiddlewares, ThemeMiddlewares } from '@core/middlewares'
import { App } from '@core/routes'
import { SentryConfig } from '@core/services'
import '@core/assets/css/global.css'

DayJSMiddlewares.setLocale()
ThemeMiddlewares.SetTheme()

SentryConfig()

ReactDOM.createRoot(document.getElementById('root')!).render(<App />)
